export enum PaymentFormStepTypeEnum {
  STEP_OPT_IN = 'STEP_OPT_IN',
  STEP_PAYMENT = 'STEP_PAYMENT',
}
